import {createSlice, isAnyOf, type SliceSelectors} from '@reduxjs/toolkit'

import {getMaskingEmail, getMaskingPhoneNumber} from '@shared/helpers/string'

import {restoreSavedState, restoreState} from '@web/actions/restoreState'
import {fetchWaitingState} from '@web/actions/waiting'
import {UserAuthStatus} from '@web/core/constants'
import {startApply} from '@web/slices/orderProcessor/slice'
import {
    setAdultToken,
    setAlarmType,
    clearAdultToken,
    PurchaserState,
    getInitialState,
} from '@web/slices/purchaser/slice'

import {MakeSliceOptions, PurchaserReducers} from './interfaces'

export default (options?: MakeSliceOptions) =>
    createSlice<PurchaserState, PurchaserReducers, 'purchaser', SliceSelectors<PurchaserState>>({
        name: 'purchaser',
        initialState: getInitialState(),
        reducers: {
            updateAlarmType(state, {payload}) {
                state.alarmType = payload
            },
            resolvedDuplicatedPhoneNumber(state, {payload: {phoneNumber, emailAddress}}) {
                state.phoneNumber = getMaskingPhoneNumber(phoneNumber)
                state.emailAddress = emailAddress ? getMaskingEmail(emailAddress ?? '') : state.emailAddress
                state.duplicatePhoneNumberUsingMember = false
            },
            setEmail(state, {payload}) {
                state.emailAddress = getMaskingEmail(payload)
            },
            setPhoneNumber(state, {payload}) {
                state.phoneNumber = getMaskingPhoneNumber(payload)
            },
            setRefundMethodType(state, {payload}) {
                state.refundMethodType = payload
            },
            updateRefundAccounts(state, {payload}) {
                state.refundAccounts = payload
            },
        },
        extraReducers: (builder) => {
            builder
                .addCase(setAlarmType, (state, {payload}) => {
                    state.alarmType = payload
                })
                .addCase(setAdultToken, (state, {payload}) => {
                    state.adultAuthentication.token = payload.token
                    state.adultAuthentication.certificationMethod = payload.certificationMethod
                })
                .addCase(clearAdultToken, (state) => {
                    state.adultAuthentication.token = ''
                    state.adultAuthentication.certificationMethod = null
                })
                .addCase(startApply.fulfilled, (state, {payload}) => {
                    state.naverIdNo = payload.naverIdNo ?? ''
                })
                .addCase(fetchWaitingState.fulfilled, (state, {payload}) => {
                    state.userAuthStatus = payload.userAuthStatus ?? UserAuthStatus.CERTIFICATE
                })
            options?.extraReducers?.(builder)
            builder.addMatcher(isAnyOf(restoreSavedState.fulfilled, restoreState), (state, {payload}) => {
                return payload.purchaser ?? state
            })
        },
    })
